<template>
  <b-row>
    <b-col>
      <b-row
        align-h="between"
        class="mb-50"
      >
        <b-col cols="10">
          <div style="display: flex;justify-content: center;">
            <h4 style="margin-bottom: 0.8rem">
              Radar de entrega dos documentos por equipe
            </h4>
            <div style="padding-left: 0.4rem">
              <i
                v-b-tooltip.hover
                :title="descricao"
                style="font-size: 0.85rem;"
                class="question-icon"
              >
                <font-awesome-icon
                  :icon="faQuestionCircle"
                />
              </i>
            </div>
          </div>
        </b-col>
        <b-col cols="auto">
          <div>
            <b-btn
              v-b-tooltip.hover
              title="Download planilha"
              variant="none"
              @click="gerarDados"
            >
              <font-awesome-icon
                :icon="faDownload"
              />
            </b-btn>
          </div>
          <a
            id="download"
            download
            href=""
            hidden
          />
        </b-col>
      </b-row>
      <b-row
        align-h="end"
        class="mb-1"
      >
        <b-col cols="auto">
          <flat-pickr
            ref="calendario"
            v-model="competencia"
            class="form-control"
            :config="options"
            @on-change="onChange"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <dashboard-barra
            v-if="carregado"
            :dados="dados"
            :categorias="labels"
          />
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>

<script>
import moment from 'moment'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faQuestionCircle, faDownload,
} from '@fortawesome/free-solid-svg-icons'
import flatPickr from 'vue-flatpickr-component'
import api from '@/app-modulo/documento/dashboard-cobranca/shared/services/api'

export default {
  name: 'EntregaDocumentosEquipe',
  components: {
    FontAwesomeIcon,
    flatPickr,
    dashboardBarra: () => import('@/shared/components/grafico-barras/GraficoBarras.vue'),
  },
  data() {
    return {
      faQuestionCircle,
      faDownload,
      carregado: false,
      labels: [],
      descricao: 'Para o índice "Concluídos" são considerados os status "Homologado" e "Dispensado", para o índice "Ação com Auditar" é considerado o status "Aguardando homologação" e para o índice "Ação com cliente" é considerado os status "Pendente" e "Recusado". Nesse gráfico somente é validado os documentos recorrentes das empresas ativas.',
      competencia: [],
      options: {
        mode: 'range',
        dateFormat: 'm/Y',
        // eslint-disable-next-line global-require
        locale: require('flatpickr/dist/l10n/pt').default.pt,
      },
      now: new Date(),
      dadosExportacao: {
        campos: ['Razão social', 'Inscrição', 'Competência', 'Departamento', 'Status do documento', 'Documento', 'Responsável'],
        datas: [],
      },
      dados: {
        concluidos: [],
        acaoAuditar: [],
        acaoCliente: [],
      },
    }
  },
  created() {
    this.competencia.push(new Date(this.now.getFullYear(), this.now.getMonth() - 1))
    this.dadosExportacao.datas.push(moment(new Date(this.now.getFullYear(), this.now.getMonth() - 1)).format('DD/MM/YYYY'))
    this.carregarDados()
  },
  methods: {
    carregarDados() {
      api.getDocumentosEquipe(this.dadosExportacao.datas)
        .then(payload => {
          payload.data.forEach(each => {
            this.dados.concluidos.push(each.documentosConcluidos)
            this.dados.acaoAuditar.push(each.documentosAcaoAuditar)
            this.dados.acaoCliente.push(each.documentosAcaoCliente)
            this.labels.push(each.equipe)
          })
          this.carregado = true
        })
    },
    gerarDados() {
      this.$isLoading(true)
      api.gerarPlanilhaDocumentosEquipes(this.dadosExportacao)
        .then(payload => {
          if (payload.data.url !== '') {
            document.getElementById('download').href = payload.data.url
            document.getElementById('download').click()
          }
          this.deletarUpload(payload.data.fileName)
        })
        .catch(err => {
          this.$isLoading(true)
          this.$erroResponse(err)
          throw err
        })
    },
    deletarUpload(data) {
      setTimeout(() => {
        api.deleteUpload(data)
          .then(resolve => {
            this.$isLoading(false)
            this.$sucesso('Planilha gerada com sucesso')
            resolve()
          })
      }, 3000)
    },
    onChange(selectedDates, dateStr) {
      if (selectedDates && selectedDates.length === 2) {
        this.carregado = false
        this.dados.concluidos = []
        this.dados.acaoAuditar = []
        this.dados.acaoCliente = []
        this.labels = []
        this.dadosExportacao.datas = []
        this.dadosExportacao.datas = dateStr.split(' até ')
        this.carregarDados()
      }
    },
  },
}
</script>
